import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
export interface User {
  id: string;
  name: string;
  email: string;
  website: string;
}
@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  private readonly http = inject(HttpClient);

  api: string = 'https://jsonplaceholder.typicode.com/users';
  getUsers(): Observable<User[]> {
    return this.http.get<User[]>(this.api);
  }
}
